export const NO_RATINGS = 'No ratings yet.';

/** The whole row as one phrase for assistive technology. */
export const ratingRowLabel = (star: number, count: number) =>
  `${star} ${star === 1 ? 'star' : 'stars'}, ${count} ${count === 1 ? 'review' : 'reviews'}`;
